import {
  axiosInstance,
  misbarInstance,
  misbarInstanceV2,
  misbarInstanceV3,
  misbarInstanceV4,
} from "api/services/axiosInstance";
import { PROJECT_URL } from "constants/ApiConstants";
import qs from "qs";

const bookingApi = {
  getProjectParcelAPI: (projectId, projectParcelId) =>
    axiosInstance.get(`${PROJECT_URL}/${projectId}/parcels/${projectParcelId}`),
  getProjectParcelsAPI: (projectId, searchKeys, cancelToken) => {
    return axiosInstance.get(`${PROJECT_URL}/${projectId}/parcels`, {
      params: {
        ...searchKeys,
      },
      cancelToken,
    });
  },
  getProjectParcelsFilterSettingsAPI: (projectId, cancelToken) =>
    axiosInstance.get(`${PROJECT_URL}/${projectId}/parcels/filters/settings`, {
      cancelToken,
    }),
  getProjectOrdersAPI: (projectId, searchKeys, cancelToken) => {
    const params = {
      ...searchKeys,
    };
    return axiosInstance.get(`${PROJECT_URL}/${projectId}/orders`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      cancelToken,
    });
  },
  getOrdersExcelSheetAPI: (projectId, searchKeys) => {
    const params = {
      projectId,
      ...searchKeys,
    };
    return axiosInstance.get(`CsvExport/ExportOfflineOrders`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
  getProjectOrdersByParcelAPI: (projectId, parcelId) =>
    axiosInstance.get(`${PROJECT_URL}/${projectId}/orders`, {
      params: { parcelId },
    }),
  changeParcelsStatus: (projectId, status, parcelsIds) => {
    let initialText = "";
    parcelsIds.forEach((id, index) =>
      index === 0
        ? (initialText += `projectParcelId=${id}`)
        : (initialText += `&projectParcelId=${id}`)
    );
    return axiosInstance.put(
      `${PROJECT_URL}/${projectId}/parcels/status/${status}?${initialText}`
    );
  },
  getStatesList: (countryId, cancelToken) =>
    axiosInstance.get(`addresses/ddlStates`, {
      params: { countryId },
      cancelToken,
    }),
  getCitiesList: (stateId, cancelToken) =>
    axiosInstance.get(`addresses/ddlCities`, {
      params: { stateId },
      cancelToken,
    }),
  getMunicipalitiesList: (countryId, stateId, cityId, cancelToken) =>
    axiosInstance.get(`addresses/ddlMunicipalities`, {
      params: { countryId, stateId, cityId },
      cancelToken,
    }),
  getNeighborhoodsList: (countryId, stateId, cityId, cancelToken) =>
    axiosInstance.get(`addresses/ddlNeighborhoods`, {
      params: { countryId, stateId, cityId },
      cancelToken,
    }),
  getLatestTransactions: (searchKeys, cancelToken) =>
    misbarInstance.get(`subdivision/transaction/search`, {
      params: { ...searchKeys, pageSize: searchKeys.limit },
      headers: {
        "TransactionTrackerAPIKey": 'a8e14f6b-92d7-4c35-b1ea-7d3f9c5e2a81'
      },
      cancelToken,
    }),
  getMetricsRange: (searchKeys, cancelToken) =>
    misbarInstance.get(`subdivision/metricsDateRanges`, {
      params: { ...searchKeys },
      cancelToken,
    }),
  getTransactionTrackerRegions: (organizationsId, cancelToken) =>
    misbarInstance.get(`bo/regions/${organizationsId}`, { cancelToken }),
  getSuggestionsSubdivisions: (params, cancelToken) =>
    misbarInstance.get(`subdivision/suggestions/number`, {
      params: { ...params },
      cancelToken,
    }),
  searchSubdivisions: (searchkeys, cancelToken) =>
    misbarInstanceV2.get(`subdivisions`, {
      params: { ...searchkeys },
      cancelToken,
    }),
  searchParcels: (searchkeys, cancelToken) =>
    misbarInstanceV3.get(`parcels`, {
      params: { ...searchkeys },
      cancelToken,
    }),
  getPacelTransactions: (searchKeys, cancelToken) =>
    misbarInstanceV4.get(`transactions`, {
      params: { ...searchKeys, pageSize: searchKeys.limit },
      headers: {
        "TransactionTrackerAPIKey": 'a8e14f6b-92d7-4c35-b1ea-7d3f9c5e2a81'
      },
      cancelToken,
    }),
  getSubdivisionsMapParcels: (searchKeys, cancelToken) => {
    const params = {
      ...searchKeys,
    };
    return misbarInstance.get(`subdivision/map/parcels`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      headers: {
        "TransactionTrackerAPIKey": 'a8e14f6b-92d7-4c35-b1ea-7d3f9c5e2a81'
      },
      cancelToken,
    });
  },
  getMapNotes: (searchKeys, cancelToken) => {
    const params = {
      ...searchKeys,
    };
    return misbarInstance.get(`subdivision/map/transactionsnotes`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      cancelToken,
    });
  },
  getTransactionData: (searchKeys) =>
    misbarInstanceV3.get(`transactionsbyno`, {
      params: { ...searchKeys },
    }),
  getTrackedSubdivisons: (searchKeys, region) =>
    axiosInstance.get(`api/transtracker/subdivisions/${region}`, {
      params: { ...searchKeys },
    }),
  trackSubdivison: (body) => axiosInstance.post(`api/transtracker`, body),
  deleteSubdivisonTrack: (subdivisionId) =>
    axiosInstance.delete(`api/transtracker/${subdivisionId}`),
  addTransactionNote: (body) =>
    axiosInstance.post(`api/transtracker/transaction/note`, body),
};

export default bookingApi;
